import { Component, OnInit } from "@angular/core";
import { filter } from "rxjs/operators";

import { Store } from "@ngxs/store";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

import { Feature } from "@motorcitysystems/core";
import { FeaturePipe, ProfileState } from "ng-identity-ui";
import { NavHeader, NavType, SetNav } from "ng-mcs-desktop";

@UntilDestroy()
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  private zendeskIdentityUrl: string = "https://motorcity.zendesk.com/hc/en-us/categories/1500001525141-IDENTITY";

  public navHeaders: NavHeader[] = [
    {
      audiences: ["id"],
      icon: "user-lock",
      id: "access-levels",
      link: "/access-levels",
      roles: ["Developer", "Administrator"],
      title: "Access Levels",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      dev: true,
      icon: "th-large",
      id: "applications",
      link: "/applications",
      roles: ["Developer"],
      title: "Applications",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      icon: "id-badge",
      id: "clients",
      link: "/clients",
      roles: ["Developer", "Administrator"],
      title: "Clients",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      dev: true,
      icon: "layer-group",
      id: "tenants",
      link: "/tenants",
      roles: ["Developer"],
      title: "Tenants",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      icon: "layer-group",
      id: "my-tenant",
      link: "/my-tenant",
      roles: ["Administrator"],
      title: "My Tenant",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      feature: [Feature.RelayNetwork],
      icon: "handshake",
      id: "third-parties",
      link: "/third-parties",
      roles: ["Administrator"],
      strictFeature: true,
      title: "Third Parties",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      icon: "users",
      id: "users",
      link: "/users",
      roles: ["Administrator", "Developer"],
      title: "Users",
      type: NavType.application,
    },
    {
      audiences: ["id"],
      icon: "circle-info",
      id: "help",
      link: this.zendeskIdentityUrl,
      external: true,
      openNewTab: true,
      title: "Help",
      type: NavType.system,
    },
  ];

  constructor(private featurePipe: FeaturePipe, private store: Store) {}

  ngOnInit() {
    // Subscribe to profile changes to update navigation when feature flags are loaded
    this.store
      .select(ProfileState.profile)
      .pipe(
        untilDestroyed(this),
        filter((profile) => !!profile) // Only proceed when profile exists
      )
      .subscribe(() => {
        this.updateNavigation();
      });

    // Also set initial navigation in case profile is already loaded
    this.updateNavigation();
  }

  private updateNavigation(): void {
    const filteredHeaders = this.filterNavHeaders();
    this.store.dispatch(new SetNav(filteredHeaders));
  }

  private filterNavHeaders(): NavHeader[] {
    return this.featurePipe.transform(this.navHeaders, true) as NavHeader[];
  }
}
